
export enum NTHFlag {
  None,
  Some,
  All
}

export enum NTHDestination {
  Commerce,
  FraisGeneraux,
  Exploitation
}

export function orderDestinations(destinations: NTHDestination[]): NTHDestination[] {
  const order: NTHDestination[] = [NTHDestination.Exploitation, NTHDestination.Commerce, NTHDestination.FraisGeneraux];
  
  return destinations.sort((a, b) => {
      if (a === b) return 0;
      
      const indexA = order.indexOf(a);
      const indexB = order.indexOf(b);
      
      if (indexA !== -1 && indexB !== -1) {
          // Si les deux éléments sont dans l'ordre prédéfini
          return indexA - indexB;
      } else if (indexA !== -1) {
          // Si seulement a est dans l'ordre prédéfini
          return -1;
      } else if (indexB !== -1) {
          // Si seulement b est dans l'ordre prédéfini
          return 1;
      } else {
          // Si aucun des deux n'est dans l'ordre prédéfini (y compris None),
          // on les trie par leur valeur enum
          return a - b;
      }
  });
}


export function getDestByString(dest: string): NTHDestination {
  switch (dest) {
    case 'Commerce':
      return NTHDestination.Commerce
    case 'Exploitation':
      return NTHDestination.Exploitation;
    case 'Frais Généraux':
      return NTHDestination.FraisGeneraux;
  }
  return null;
}

export function getStringByDest(dest: NTHDestination): string {
  switch (dest) {
    case NTHDestination.Commerce:
      return 'Commerce'
    case NTHDestination.Exploitation:
      return 'Exploitation';
    case NTHDestination.FraisGeneraux:
      return 'Frais Généraux';
  }
  return null;
}


export function stringifyFlags(flags: NTHFlag[]): string[] {
  const response = [];
  flags.forEach(flag => {
    switch (flag) {
      case NTHFlag.All:
        response.push('Total');
        break;
      case NTHFlag.Some:
        response.push('Partiel');
        break;
      case NTHFlag.None:
        response.push('Aucun');
        break;
    }
  });
  return response;
}

export function parseFlags(flags: string[]): NTHFlag[] {
  const response = [];
  flags.forEach(flag => {
    switch (flag) {
      case 'Total':
        response.push(NTHFlag.All);
        break;
      case 'Partiel':
        response.push(NTHFlag.Some);
        break;
      case 'Aucun':
        response.push(NTHFlag.None);
        break;
    }
  });
  return response;
}
